import { jsxs as n, jsx as g } from "react/jsx-runtime";
import { clsx as R } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as B, useRef as D, useEffect as G } from "react";
import { Breakpoints as h } from "../../style/base/index.js";
import { useContainerSize as F } from "../../utils/use-container-size.js";
import e from "./roche-image.module.scss.js";
import { RocheUIImageRatio as d, RocheUIImageDPI as Z, RocheUIImagePosition as o, RocheUIImageFit as q } from "./roche-image.types.js";
import { createImageUrl as S, getRatioName as y, isImageServiceUrl as J, getPositionParsed as K } from "./roche-image-helpers.js";
const Q = 300, se = ({
  src: a,
  alt: _,
  slot: p,
  caption: t = void 0,
  copyright: r = void 0,
  ratio: i = d.HD,
  position: U = o.CENTER,
  fullscreen: v = !1,
  showCaption: f = !1,
  showCopyright: I = !1,
  bleed: E = !1,
  forceHeight: s = void 0,
  loading: T = "lazy",
  imageFit: w,
  fillContainer: x = !1
}) => {
  const O = S(a, h.SMALL, i, s), [{ fallbackSrc: c, width: P, srcSet: L }, A] = B({
    fallbackSrc: O,
    width: h.SMALL,
    srcSet: ""
  }), u = D(null), m = F(u), N = y(i), C = R({
    [e.image__img]: !0,
    [e[`image__img--ratio-${N}`]]: i !== d.ORIGINAL && N
  });
  G(() => {
    if (!J(a))
      return;
    const z = setTimeout(() => {
      const M = window.devicePixelRatio || 1;
      if (m.width) {
        const $ = Z.map((j) => {
          const k = Math.round(m.width * M);
          return `${S(a, k, i, s)} ${j}x`;
        }).join(", ");
        A({ fallbackSrc: c, width: m.width, srcSet: $ });
      }
    }, Q);
    return () => clearTimeout(z);
  }, [m, c, a, i, s]);
  const l = K(U), b = R({
    [e.image]: !0,
    [e["image--fullscreen"]]: v,
    [e["image--bleed"]]: E,
    [e["image--top"]]: l === o.TOP,
    [e["image--center"]]: l === o.CENTER,
    [e["image--bottom"]]: l === o.BOTTOM,
    [e["image--original"]]: i === d.ORIGINAL,
    [e["image--full-height"]]: s !== void 0,
    [e["image--contain"]]: w === q.CONTAIN,
    [e["image--fill-container"]]: x
  });
  return /* @__PURE__ */ n("figure", { className: b, slot: p, "data-ratio": i, children: [
    /* @__PURE__ */ g("div", { className: e.image__container, ref: u, children: /* @__PURE__ */ g(
      "img",
      {
        className: C,
        src: c,
        srcSet: L,
        sizes: `${P}px`,
        alt: _,
        title: t,
        loading: T
      }
    ) }),
    (f && t || I && r) && /* @__PURE__ */ n("div", { className: e.image__description, children: [
      f && t && /* @__PURE__ */ g("figcaption", { className: e.image__caption, children: t }),
      I && r && /* @__PURE__ */ n("div", { className: e.image__copyright, children: [
        "© ",
        r
      ] })
    ] })
  ] });
};
export {
  se as RocheUIImage
};
